import React, { useState } from "react";
import { UserPlus } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { registerMentor, uploadProfileImage } from "../utils/api";
import toast from "react-hot-toast";
import Logo from "../assest/tactosnew.png";

const MentorRegister = () => {
  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null)
  const [loader, setLoader] = useState(false)
  const navigate = useNavigate()
  const [data, setData] = useState({
    name: "",
    password: "",
    email: "",
    number: null,
    profession: "",
    linkedinProfile: "",
    expertise: "",
    image: null,
    isActive: 1
  })

  const isFormInvalid =
    !data.name ||
    !data.email ||
    !data.password ||
    !data.number;


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file)
      setPreview(URL.createObjectURL(file));
    }
  };

  const onRegisterClick = async () => {
    setLoader(true)
    try {
      const payload = { ...data };
      if (selectedFile) {
        const fileUploadResponce = await uploadProfileImage(selectedFile)
        console.log(fileUploadResponce)
        payload.image = fileUploadResponce
      }
      console.log(payload)
      const res = await registerMentor(payload)
      toast.success(res.message)
      navigate('/mentorlogin')
    } catch (error) {
      console.log(error)
      toast.error(error?.response?.data?.message)
    } finally {
      setLoader(false)
      setSelectedFile(null)
      setPreview(null)
      setData({
        ...data, name: "",
        password: "",
        email: "",
        number: null,
        profession: "",
        linkedinProfile: "",
        expertise: "",
        image: null,
        isActive: 1
      })
    }
  }

  return (
    <section className="min-h-screen bg-gray-50 flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl p-8">
        {/* LOGO */}
        <div className="flex justify-center mb-6">
          <img
            src={Logo}
            alt="Tactos Logo"
            className="h-12 object-contain"
          />
        </div>

        {/* HEADER */}
        <div className="mb-8">
          <h2 className="text-3xl font-extrabold text-gray-900">
            Mentor Registration
          </h2>
          <p className="text-gray-600 text-sm mt-2">
            Apply to become a mentor at Tactos
          </p>
        </div>

        {/* PROFILE IMAGE */}
        <div className="mb-8">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Profile Image
          </label>

          <div className="flex items-center gap-4">
            <div className="w-20 h-20 rounded-lg border-2 border-dashed border-gray-300 flex items-center justify-center overflow-hidden">
              {preview ? (
                <img
                  src={preview}
                  alt="Preview"
                  className="w-full h-full object-cover"
                />
              ) : (
                <UserPlus className="text-gray-400" />
              )}
            </div>

            <div>
              <input
                type="file"
                accept="image/png, image/jpeg"
                onChange={handleImageChange}
                className="text-sm"
              />
              <p className="text-xs text-gray-500 mt-1">
                PNG, JPG up to 10MB
              </p>
            </div>
          </div>
        </div>

        {/* FORM */}
        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* FULL NAME */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Full Name *
            </label>
            <input
              required
              value={data.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
              type="text"
              placeholder="Enter full name"
              className="   w-full px-4 py-3
  border border-gray-200 rounded-lg
  bg-white
  transition-all duration-200
  focus:border-gray-400
  focus:shadow-sm
  outline-none"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Phone Number *
            </label>
            <input
              required
              value={data.number}
              onChange={(e) => setData({ ...data, number: e.target.value })}
              type="tel"
              placeholder="+91 996143910"
              className="   w-full px-4 py-3
  border border-gray-200 rounded-lg
  bg-white
  transition-all duration-200
  focus:border-gray-400
  focus:shadow-sm
  outline-none"
            />
          </div>

          {/* EMAIL */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Email Address *
            </label>
            <input
              required
              value={data.email}
              onChange={(e) => setData({ ...data, email: e.target.value })}
              type="email"
              placeholder="Enter email address"
              className="   w-full px-4 py-3
  border border-gray-200 rounded-lg
  bg-white
  transition-all duration-200
  focus:border-gray-400
  focus:shadow-sm
  outline-none"
            />
          </div>


          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Password
            </label>
            <div className="relative">

              <input
                required
                value={data.password}
                onChange={(e) => setData({ ...data, password: e.target.value })}
                type="password"
                placeholder="••••••••"
                className="
                    w-full px-4 py-3 
  border border-gray-200 rounded-lg
  bg-white
  transition-all duration-200
  focus:border-gray-400
  focus:shadow-sm
  outline-none
                "
              />
            </div>
          </div>


          {/* PROFESSION */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Profession *
            </label>
            <input
              value={data.profession}
              onChange={(e) => setData({ ...data, profession: e.target.value })}
              type="text"
              placeholder="e.g. Senior Developer"
              className="   w-full px-4 py-3
  border border-gray-200 rounded-lg
  bg-white
  transition-all duration-200
  focus:border-gray-400
  focus:shadow-sm
  outline-none"
            />
          </div>



          {/* EXPERTISE */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Area of Expertise *
            </label>
            <input
              value={data.expertise}
              onChange={(e) => setData({ ...data, expertise: e.target.value })}
              type="text"
              placeholder="e.g. Web Development"
              className="   w-full px-4 py-3
  border border-gray-200 rounded-lg
  bg-white
  transition-all duration-200
  focus:border-gray-400
  focus:shadow-sm
  outline-none"
            />
          </div>

          {/* LINKEDIN */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              LinkedIn Profile
            </label>
            <input
              value={data.linkedinProfile}
              onChange={(e) => setData({ ...data, linkedinProfile: e.target.value })}
              type="url"
              placeholder="https://linkedin.com/in/username"
              className="   w-full px-4 py-3
  border border-gray-200 rounded-lg
  bg-white
  transition-all duration-200
  focus:border-gray-400
  focus:shadow-sm
  outline-none"
            />
          </div>
        </form>

        {/* SUBMIT */}
        <div className="mt-8">
          <button
            type="button"
            onClick={onRegisterClick}
            disabled={loader || isFormInvalid}
            className="
    w-full md:w-auto px-8 py-3
    bg-[#fd3e3d] text-white font-semibold rounded-lg
    hover:bg-[#e63939]
    transition-all duration-300
    flex items-center justify-center
    disabled:opacity-50 disabled:cursor-not-allowed
    transform hover:-translate-y-0.5
    relative overflow-hidden group
  "
          >
            {/* SHINE EFFECT */}
            <div
              className="
      absolute inset-0
      bg-gradient-to-r from-white/0 via-white/30 to-white/0
      -skew-x-12
      -translate-x-full
      group-hover:translate-x-full
      transition-transform duration-1000
    "
            />

            {/* CONTENT */}
            <div className="relative z-10">
              {loader ? (
                <span className="flex items-center gap-2">
                  <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  Registering
                </span>
              ) : (
                "Register"
              )}
            </div>
          </button>

        </div>

        <div className="mt-4 text-center text-sm text-gray-600">
          Already have an account?
          <Link
            to="/mentorlogin"
            className="text-[#fd3e3d] ml-1 font-medium cursor-pointer hover:underline"
          >
            Sign in
          </Link>
        </div>
      </div>
    </section>
  );
};

export default MentorRegister;
